import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	linkText: {
		id: 'rovo-extension-install-cta-left-nav.link',
		defaultMessage: 'Get the browser extension',
		description: 'Text for rovo extension install cta link left nav',
	},
	rovoIconAlt: {
		id: 'rovo-extension-install-cta-left-nav.rovo-icon-alt',
		defaultMessage: 'Rovo Icon',
		description: 'Alt text for Rovo icon image',
	},
	chromeIconAlt: {
		id: 'rovo-extension-install-cta-left-nav.chrome-icon-alt',
		defaultMessage: 'Google Chrome Icon',
		description: 'Alt text for Google Chrome icon image',
	},
	dismissLabel: {
		id: 'rovo-extension-install-cta-left-nav.dismiss-label',
		defaultMessage: 'Dismiss message',
		description: 'Label for dismiss button',
	},
});

export const COPY_VARIATIONS = {
	'copy-version-b': defineMessages({
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-b',
			defaultMessage: 'Get answers for work, anywhere',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-b',
			defaultMessage:
				'Ask about your projects, work policies, or anything about your company. Rovo Chat from any tab.',
			description: 'Description text for rovo extension install cta left nav',
		},
	}),
	'copy-version-c': defineMessages({
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
			defaultMessage: 'Unlock Rovo in every tab',
			description: 'Heading text for rovo extension install cta left nav',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
			defaultMessage: '50K+ workers use it to chat with AI that understands their company.',
			description: 'Description text for rovo extension install cta left nav',
		},
	}),
};
